import React from "react";
import _ from "lodash";
import moment from "moment";
import { Label } from "semantic-ui-react";

export const removeNullValues  = (obj) => {
  for (const key in obj) {
    if (obj[key] === null || isNaN(obj[key])) {
      delete obj[key];
    }
  }
  return obj;
}

export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value?.trim().length === 0)
  );
};
export const convertDecimalToPercent = (decimal = 0) => {
  if (isNaN(decimal)) return; //escape

  if (decimal === 1) {
    return 100;
  } else {
    let num = decimal * 100;
    return Number(num.toPrecision(3))  //remove insignificant number and show 2 decimal 
     
  }
};
export const convertPercentToDecimal = (percent = "1%") => {
  // if (percent === "100%") return 1;
  const num = parseFloat(percent) / 100;
  return Number(num.toPrecision(4)); //remove insignificant number and add show 4 decimal and Add 4 decimal point
};
export const round = (x, precision) => {
  var y = +x + (precision === undefined ? 0.5 : precision / 2);
  return y - (y % (precision === undefined ? 1 : +precision));
};
export const displayServerError = (err) => {
  const message =
    err && err.response && err.response.data && err.response.data.message;

  if (
    message ===
    "Voiding is only possible when the payment status is new or partial"
  ) {
    alert("Voiding an order with fully paid Kasuki pay later is not allowed");
  } else {
    alert(message);
  }
};

export const truncate = (text, n) => {
  n = n || 40;
  if (text.length > n) text = text.substring(0, n - 1) + "...";
  return text;
};

export const lastChar = (text) => String(text).substr(-1);

export const validNumber = (text) => {
  if (typeof text === "string") return _.isFinite(Number(text));
  else if (typeof text === "number") return _.isFinite(Number(text));
  else return false;
};

export const acceptEmptyNumber = (text) => {
  const inputValue = !text && text !== 0 ? "" : text;

  if (inputValue > 0) {
    return false;
  } else if (inputValue === "") {
    return false;
  } else {
    return true;
  }
};

export const validPercent = (value) => {
  if (lastChar(value) !== "%") return false;
  else if (value === "%") return false;
  else if (value.split("%")[0] < -99) return false;
  else {
    const numberPart = value.split("%")[0];
    return _.isFinite(Number(numberPart));
  }
};

export const percentToValue = (value) => {
  if (lastChar(value) !== "%") return NaN;
  else {
    const numberPart = value.split("%")[0];
    return Number(numberPart) / 100;
  }
};

export const valueToPercent = (value) => {
  return `${value * 100}%`;
};

export const joinInEnglish = (array, conjunction) => {
  const n = _.size(array);
  const word = _.defaultTo(conjunction, "and");

  if (n === 1) return array[0];
  else if (n === 2) return `${array[0]} ${word} ${array[1]}`;
  else {
    const lastElement = array.pop();
    return `${array.join(", ")} ${word} ${lastElement}`;
  }
};

export const computeCharges = (charges) => {
  const result = Object.values(
    charges.reduce((c, { name, code, fee }) => {
      c[name] = c[name] || { name, code, fee: 0 };
      c[name].fee += fee;
      return c;
    }, {})
  );

  return result;
};

export const totalWithCharges = (charges) => {
  const getTotal = charges.reduce((charge, obj) => {
    const isEnableDeposit = JSON.parse(localStorage.getItem("auth")).settings;
    
    const fee = isEnableDeposit.enable_bottle_deposit ? 
        obj.fee 
      : obj.code !== "bottle_deposit_amount" && obj.code !== "case_deposit_amount" ? obj.fee : 0
    return charge + fee
  }, 0);

  return getTotal;
};

export const totalKasukipaylater = (payments) =>
  _.sumBy(payments, (payment) => {
    let total = 0;

    return payment.payment_type === "kasuki_pay_later"
      ? payment.amount + total
      : 0;
  });

export const totalKasukiHandlingFee = (charges) =>
  _.sumBy(charges, (charges) => {
    let total = 0;

    return charges.code === "kasuki_handling_fee" ? charges.fee + total : 0;
  });

export const removeEmptyCoupon = (coupons) => {
  const couponWithValue = coupons?.filter(
    (coupon) => coupon?.amount || coupon?.value
  );
  return couponWithValue;
};

export const totalCoupon = (coupon) => {
  const couponWithValue = removeEmptyCoupon(coupon);
  const getTotal = couponWithValue.reduce((prev, current) => {
    return prev + current?.value;
  }, 0);
  return getTotal || 0;
};

export const totalDeliveryDiscount = (fees, coupons) => {
  let total = 0;

  total = _.sumBy(coupons, (coupon) => {
    return coupon.code === "delivery_discount"
      ? !_.isUndefined(coupon.delivery_discount_percent)
        ? coupon.value + total
        : coupon.delivery_discount_value + total
      : 0;
  });
  return total;
};

export const totalRebate = (coupons) =>
  _.sumBy(coupons, (coupon) => {
    let total = 0;

    return coupon.code === "rebate" ? coupon.amount + total : 0;
  });
  
export const totalTierDiscount = (coupons) => {
 const total =  coupons?.filter((coupon) => coupon.code === "tier_discount" )
 .reduce((prev, current) => prev + current.value
   , 0)
   return total
}

export const totalSurcharge = (charges) =>
  _.sumBy(charges, (charge) => {
    let total = 0;

    const grandTotal = charge.code !== "delivery" &&
      charge.code !== "pickup" &&
      charge.code !== "kasuki_handling_fee"
      ? charge.fee + total
      : 0;
    const grandTotalWithDeposit = charge.code !== "delivery" && charge.code !== "pickup" && charge.code !== "kasuki_handling_fee" && charge.code !== "bottle_deposit_amount" && charge.code !== "case_deposit_amount"
      ? charge.fee + total
      : 0;

    const isEnableDeposit = JSON.parse(localStorage.getItem("auth")).settings;
    return isEnableDeposit.enable_bottle_deposit ? grandTotal : grandTotalWithDeposit
  });

export const totalDeliveryFee = (charges) =>
  _.sumBy(charges, (charge) => {
    let total = 0;

    return charge.code === "delivery" || charge.code === "pickup"
      ? charge.fee + total
      : 0;
  });

export const snakeToString = (str) =>
  str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace("-", " ").replace("_", " ")
  );

export const isLessThan7Days = (delivery_date) => {
  const dateAfter7Days = moment(delivery_date).add(7, "days");
  return moment.utc().isBefore(moment.utc(dateAfter7Days));
};

export const getSortedItems = (orders) => {
  if (_.isEmpty(orders)) return [];

  const outOfStockItems = _.filter(orders, (item) => item.quantity === 0);

  const availableItems = _.filter(
    orders,
    (item) => item.original_quantity !== 0 && item.quantity !== 0
  );

  const addOns = _.filter(
    orders,
    (item) =>
      (item.original_quantity === 0 && item.quantity > 0) ||
      item.quantity > item.original_quantity
  );
  const additionalItems = _.filter(
    addOns,
    (i) => !_.find(availableItems, { barcode: i.barcode })
  );

  return { outOfStockItems, availableItems, additionalItems, isEmpty };
};
export const toUpperCaseFirstLetterWord = (sentence) => {
  const words = sentence?.split(" ");

  return words?.map((word) => {
      return word[0]?.toUpperCase() + word?.substring(1);
    })
    .join(" ");
};

export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};

export const isWeakPassword = (password) => {
  const re = new RegExp(
    "^(?=.*([A-Z]){1,})(?=.*[a-z]{1,})(?=.*[0-9]{1,})(?=.*[^A-Za-z0-9]{1,}).{12,}$"
  );
  const common = /pass|word|qwer|asdf|1234/i;
  return !(password && re.test(password) && !common.test(password));
};

export const generateStrongPassword = (password_length = 12) => {
  // Note: Can be shorter than default if specified!
  const pickChars = (set, max) => {
    max = max || 1;

    let count = Math.floor(Math.random() * max + 1);

    let l = set.length;
    let result = "";
    for (let i = 0; i < count; ++i) {
      const ch = set.charAt(Math.floor(Math.random() * l));
      result += ch;
    }
    return result;
  };

  const ranges = [
    // confusing/difficult characters removed
    "ABCDEFGHJKLMNPQRSTUVWXYZ", // upper; IO
    "abcdefghijkmnopqrstuvwxyz", // lower; l
    "23456789", // digits; 01
    '!@#$%&*()-=+[{]}",<.>/?', // special ~`|';:\_^
  ];

  let password = "";
  let r = 0;
  while (isWeakPassword(password)) {
    // choose from the ranges if still less than len after first pass
    const i = r < 4 ? r++ : Math.floor(Math.random() * 3);
    password = password + pickChars(ranges[i], i === 3 ? 1 : 4 - i); // 4, 3, 2, 1
  }

  // Trim excess
  if (password.length > password_length)
    password = password.substring(0, password_length);

  return password;
};

export const generateID = () => String(Date.now());

export const isValidUrl = (urlString)=> {
  try { 
    return Boolean(new URL(urlString)); 
  }
  catch(e){ 
    return false; 
  }
}

export const isValidNumber = (value) => {
  let pattern = /^[0-9]+$/
  return pattern.test(value)
}

export const isValidMobileNumber = (value) => {
  let pattern = /^[+]?[0-9]*$/
  return pattern.test(value)
}

export const isFloat =(n) => {
  return Number(n) === n && n % 1 !== 0;
}

export const hasWhiteSpace = (s) => {
  return /\s/g.test(s);
}
export const hasSpecialCharacters = (s) => {
  const regex = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
  return regex.test(s);
}

export const hasNumbers = (string) => {
   return /[^a-zA-Z]/.test(string)
}

export const removeDuplicateArray = (array) => {
  return [...new Set(array)];
}
export const Keywords = ({ keywords }) => {
  return _.isEmpty(keywords)
    ? null
    : _.map(keywords, (keyword, i) => (
        <Label size="mini" key={`K${i}`}>
          {keyword}
        </Label>
      ));
};

export const Tags = ({ tags }) => {
  return _.isEmpty(tags)
    ? null
    : _.map(tags, (tag, i) => (
        <Label color="blue" size="mini" key={`K${i}`}>
          {tag}
        </Label>
      ));
};

export const rowKey = (record) => {
  return record?._id  || record?.adjustment_id
}

export const isObject = (obj) => {
 return typeof obj === 'object' &&
  !Array.isArray(obj) &&
  obj !== null
}

export const deleteKeysInObject = (keysToDelete, object) => {
	keysToDelete.forEach(key => {
	  // Use try-catch to handle cases where the key doesn't exist in the object
	  try {
		// Split the key into nested properties
		const keys = key.split('.');
		
		// Use reduce to navigate through nested properties and delete the key
		keys.reduce((nestedObject, currentKey, index) => {
		  if (index === keys.length - 1) {
			// Delete the key if it's the last one in the chain
			delete nestedObject[currentKey];
		  } else {
			// Navigate to the next nested property
			return nestedObject[currentKey];
		  }
		  return nestedObject; // Return the accumulator
		}, object);
	  } catch (error) {
		// Handle errors if the key doesn't exist in the object
		console.error(`Error deleting key "${key}": ${error.message}`);
	  }
	});
  
	return object;
  }
  
  export const anyKeyStartsWith = (collection, text) => {
	let result = false;
	_.forEach(collection, (value, key) => {
	  if (key.startsWith(text) && value) result = true;
	});
	return result;
  };
  
